import React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import DataTable, { Column, Action } from '@/components/DataTable';
import { setHours, setMinutes, setSeconds } from '@/utils/datetime';
import { ArticlePrice, Price, ServicePriceMapping } from '@/types';
import { Segment } from 'semantic-ui-react';
import ArticleSearchSelect from './ArticleSearchSelect';
import classnames from 'classnames/bind';
import styles from './PriceArticleMappingsTable.module.css';
import { UpdatedPrices } from '@/store/reducers/eaccounting';


const cx = classnames.bind(styles);

const vatPercentRenderer = (row: Price) => (
    `${row.VAT * 100}%`
);

export const parseTime = (time: string) => {
    const strs = time.split(':');
    let dateObj = new Date();

    dateObj = setHours(dateObj, parseInt(strs[0]));
    dateObj = setMinutes(dateObj, parseInt(strs[1]));
    dateObj = setSeconds(dateObj, parseInt(strs[2]));

    return dateObj;
};

interface Props extends LocalizeContextProps {
    prices: Price[];
    priceMappings: ServicePriceMapping[];
    updatedPrices: UpdatedPrices;
    onUpdateMapping: (price: ArticlePrice) => void;
    onRemoveMapping: (id: string) => void
    renderSaveButton: () => React.ReactElement
}


const descriptionRenderer = (row: ArticlePrice & { _serviceName: string }) => (
    row._serviceName ? row._serviceName : ''
)

function PriceArticleMappingsTable(props: Props) {
    const { translate, onUpdateMapping, onRemoveMapping, priceMappings, updatedPrices, renderSaveButton } = props;
    let columns: Column[] = [];

    const rendererEaccountingArticle = (row: ArticlePrice, rowIndex: number) => {

        const matchedPrice = updatedPrices.changed
            ? updatedPrices.entities.find(p => p.PriceId === row.Id)
            : priceMappings.find(p => p.PriceId === row.Id)

        const selectedReference = matchedPrice?.ExternalReference;

        return row.PriceText ? (
            <div className={cx('dropdown-container')}>
                <ArticleSearchSelect
                    upward={rowIndex === props.prices.length}
                    key={`${row.Id}-${selectedReference}`}
                    data-cy={`select-mapping-article-${rowIndex}`}
                    value={selectedReference}
                    // FIXME: type row correctly (with Price)
                    // @ts-ignore
                    vatPercent={parseFloat(row.VAT)}
                    onChange={(articleId) => {
                        if (!articleId) {
                            onRemoveMapping(row.Id.toString());
                        } else {
                            onUpdateMapping({
                                ...row,
                                ExternalReference: articleId,
                            });
                        }
                    }}
                />
            </div>
        ) : null;
    };

    columns = [
        ...columns,
        { name: 'Id', attribute: 'Id' },
        { name: translate('prices.serviceName'), renderer: descriptionRenderer },
        {
            name: translate('prices.Price'),
            attribute: 'PriceText',
        },
        {
            name: translate('prices.VAT'),
            renderer: vatPercentRenderer
        },
        { name: translate('prices.eaccountingArticle'), renderer: rendererEaccountingArticle },
    ];

    const rowActions: Action[] = [];

    return (
        <Segment>
            <DataTable
                style={{ minHeight: '600px' }}
                columns={columns}
                data={props.prices}
                actions={rowActions}
                virtualized
                nowrap
            />
            {renderSaveButton()}
        </Segment>
    );
}




export default withLocalize(PriceArticleMappingsTable);
